export default {
  data() {
    return {
      items: [
        {
          title: this.$t("header.menu.investing.staking"),
          link: `${process.env.VUE_APP_PUBLIC_BASE_URL}/market/staking`,
          icon: "$staking",
          external: true
        },
        {
          title: this.$t("header.menu.dealing.fastConvert"),
          link: "/operations/exchange",
          icon: "$fastConvert"
        },
        // {
        //   title: this.$t("header.menu.dealing.perfectMoney"),
        //   link: "/fiat",
        //   icon: "$perfectMoney"
        // },
        {
          title: this.$t("header.menu.dealing.depositHistory"),
          link: "/history/transaction/deposits",
          icon: "$openOrdersHistory"
        },
        {
          title: this.$t("header.menu.dealing.withdrawHistory"),
          link: "/history/transaction/withdrawals",
          icon: "$openOrdersHistory"
        },
        {
          title: this.$t("accountPage.accountSidebar.links.gifts.title"),
          link: "/gifts",
          icon: "$vuetify.CustomIcon.giftIcon"
        },
        {
          title: this.$t("accountPage.accountSidebar.links.referral.title"),
          link: "/referral",
          icon: "$referral"
        }
      ]
    };
  },
  methods: {
    menuClick(item) {
      if (item.link === "/fiat") {
        return;
      }
      if (item.external) {
        window.open(item.link);
      } else {
        this.$router.push(item.link);
      }
    }
  }
};
